import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../login-service';
import { Router } from '@angular/router';
declare var gapi: any;
@Component({
    selector: 'inithea-app',
    templateUrl: 'initiatorhead.component.html'
})

export class InitiatorHeadComponent implements OnInit {
  badgeCount:any;ss
  tempNotiList:any;
NotificationsList:any;
    menuList:any;
    selectedMenuIteam:string;
    documentsList: any;
    filtereddocList: any;
    userID: any;
  usersList: any;
  change: string;
  name: any;
  tempUsersList: any;
  url: string;
  userTypeName:string;
  profile: any;
    constructor(private loginService:LoginService,private router: Router) {
      this.userTypeName=localStorage.getItem('userType');
     }

    ngOnInit() {
       
        this.GetMenusByUserType(1);
        this.GetUsers();
        this.userID=localStorage.getItem('USERID');
        this.GetNotifications();
        
        this.change=localStorage.getItem('PROCESS');
        // if (this.change=="signup")
        // {
        //   this.getLegaldocuments();
        // }
        // else if(this.change=="login")
        // {
        //   this.GetUsers();
        // }
     }
  SignOut(){
    // window.location.href = "https://mail.google.com/mail/u/0/?logout&hl=en";


      this.router.navigateByUrl('/login');
    
  }
     GetMenusByUserType(userTypeID){
        this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
            {
        
        data = JSON.parse(data['_body']);
        this.menuList=JSON.parse(JSON.stringify(data));
            });
            }

            menuClick(url, obj,menuName) {
                var activeclasses = document.querySelectorAll('.liactive');
                for (let i = 0; i < activeclasses.length; i++) {
                  activeclasses[i].setAttribute("class", "liactive1");
                  activeclasses[i].parentElement.setAttribute("class", "has-module1");
                }
                obj.parentNode.setAttribute("class", "liactive");
                obj.parentNode.parentNode.setAttribute("class", "has-module");
                this.selectedMenuIteam=menuName;
                
                this.router.navigate([url]);
              }

            GetNotifications(){
              this.loginService.GetNotifications().subscribe(data=>
                {
                  
                  data = JSON.parse(data['_body']);
                        this.tempNotiList=JSON.parse(JSON.stringify(data));
                        this.badgeCount=this.NotificationsList.length;

                });

            }
             GetUsers(){
              this.loginService.GetUsers(this.userTypeName).subscribe(data=>
                {
                  
                  data = JSON.parse(data['_body']);
                        this.usersList=JSON.parse(JSON.stringify(data));
                        for(let i=0;i<this.usersList.length;i++)
                        {
                        
                        if(this.userID==this.usersList[i].id)
                        {
                          this.name=this.usersList[i].first_name;
                        }
                      }
                      let filterUser=this.usersList.filter(x=>x.id.toString()==this.userID.toString());
      if(filterUser.length>0){
        this.tempUsersList=filterUser[0];
        if(this.tempUsersList.Profile!==null ){
        //  this.url="http://localhost:25396/"; 
        this.url=this.loginService.imageURL;
         
        }
        else{
          this.url="";
          this.tempUsersList.Profile='../../assets/images/user.png';
          
        }
      }
                });
            }

            
         
}
